import { ResourceBase, ResourceType } from './resource-base';
import { SectionData } from './section';
import { CollectionData } from './collection';

export interface Brandfolder {
  id: string;
  name: string;
  sections: SectionData;
  collections: CollectionData;
}

export const BRANDFOLDER_REPO_TOKEN = Symbol.for('BRANDFOLDER_REPO');

export interface IBrandfolderRepo {
  getBrandfolder: (
    brandfolderId: string,
  ) => Promise<Brandfolder>;
  listBrandfolders: () => Promise<Brandfolder[]>;
}
